function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Deeply merges multiple objects. If objects contain an object at the same key, it merges those objects recursively.
 * For keys with array values, it concatenates the arrays. If an object is null or undefined, it's skipped.
 *
 * @param {Object<string, any> | null} targetObj - The target object to merge into.
 * @param {...Object<string, any> | null} sourceObjs - One or more source objects to merge from.
 * @returns {Object<string, any>} The merged object.
 *
 * @example
 * // Merges multiple flat objects
 * mergeDeep({ a: 1 }, { b: 2 }, { c: 3 });
 * // Returns { a: 1, b: 2, c: 3 }
 *
 * @example
 * // Merges nested objects from multiple sources
 * mergeDeep({ a: { x: 1 } }, { a: { y: 2 } }, { a: { z: 3 } });
 * // Returns { a: { x: 1, y: 2, z: 3 } }
 *
 * @example
 * // Concatenates array values from multiple sources
 * mergeDeep({ a: [1, 2] }, { a: [3, 4] }, { a: [5, 6] });
 * // Returns { a: [1, 2, 3, 4, 5, 6] }
 *
 * @example
 * // Handles null values
 * mergeDeep({ a: 1 }, null, { b: 2 });
 * // Returns { a: 1, b: 2 }
 */
export function mergeDeep(targetObj) {
  for (var _len = arguments.length, sourceObjs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    sourceObjs[_key - 1] = arguments[_key];
  }
  if (!targetObj) {
    targetObj = sourceObjs.find(obj => obj != null) || {};
  }
  var result = _objectSpread({}, targetObj);
  var _loop = function _loop(sourceObj) {
    if (!sourceObj) {
      return 1; // continue
    }
    Object.keys(sourceObj).forEach(key => {
      var targetValue = result[key];
      var sourceValue = sourceObj[key];
      var isBothArrays = Array.isArray(targetValue) && Array.isArray(sourceValue);
      var isBothObjects = typeof targetValue === 'object' && targetValue !== null && typeof sourceValue === 'object' && sourceValue !== null && !Array.isArray(targetValue) && !Array.isArray(sourceValue);
      if (isBothArrays) {
        result[key] = [...targetValue, ...sourceValue];
      } else if (isBothObjects) {
        result[key] = mergeDeep(targetValue, sourceValue);
      } else {
        result[key] = sourceValue;
      }
    });
  };
  for (var sourceObj of sourceObjs) {
    if (_loop(sourceObj)) continue;
  }
  return result;
}